/**
 * @fileoverview Главный скрипт для работы с Qform. Здесь инициируется namespace Qform, лежат общие методы и свойства.
 *
 * @version 2.0.0
 * @author Igor I. Kuzmin <random@academic.ru>
 */

/**
 * @namespace Основной модуль для работы с qform 2.0
 */

var QDebugDiv = $("#q-debugging-div__").dblclick(function(){$(this).hide();});

window.Q_DEBUG_MODE = !!QDebugDiv.length;

window.qdebuginfo = function(msg)
{
	if(QDebugDiv) QDebugDiv.text(msg).show();
};

window.Q = {};

Q.WORKSPACE = '';

Q.reports = {};
Q.debug = {};
Q.QUGGLER_F2_BINDED = false;

$(document).ready(function()
{

    Q.fnInit();

	$(document).click(function (e)
	{
		// check the parents to see if we are inside of a tool tip.  If the click came
		// from outside the tooltip, then hide our tooltip
		if ($(e.target).parents('.popover').length == 0 && !$(e.target).is(".open-files-link"))
		{
			$('a.open-files-link').popover('hide');
		}
	});
	/****
	$(document).resize(function (e)
	{
		$('a.open-files-link').popover('hide');
	});
/****/

	$("div.dataTables_scrollBody").scroll(function(e)
	{
		$('a.open-files-link').popover('hide');
	});


	$(document).keydown(function(event)
	{
		if(event.which == KEY.ESC) // ESC
		{
			var $Modal = $("body > div.modal-wrapper").last().children("div.modal-dialog");
			$Modal.modal('hide');
		};
	});


	$(document).ajaxComplete( function(e, xhr, ajaxOptions)
	{
		Q.debug.fnProcessHeaders(xhr);
	});

});

Q.debug.fnProcessHeaders = function(xhr)
{
	var sSqlType = xhr.getResponseHeader('X-Q-SQL-type');
	var sSqlText = xhr.getResponseHeader('X-Q-SQL-text');
	var sSqlError = xhr.getResponseHeader('X-Q-SQL-error');

	if(!empty(sSqlType))
	{
		console.groupCollapsed(!empty(sSqlError)?'!! Ошибка в SQL запросе [%s] !!':'Выполнен SQL запрос [%s]', sSqlType);
		if(!empty(sSqlError)) console.warn(sSqlError.split('::br::').join('\n'));
		console.log('%cТекст SQL-запроса:','font-weight:bold');
		console.log(sSqlText.split('::br::').join('\n'));
		console.groupEnd();
	}

	var sStory = xhr.getResponseHeader('X-Q-Debug-Story');
	//console.log(sStory);
	if(!empty(sStory))
	{
		var oStory = $.parseJSON(sStory.split('::br::').join('\n'));
		var sAct  = xhr.getResponseHeader('X-Q-Debug-Act');
		var sFile = xhr.getResponseHeader('X-Q-Debug-File');
	}

	Q.debug.fnShowDebugStory(oStory, sAct, sFile);

	var sSqlStory = xhr.getResponseHeader('X-Q-Debug-SQL');
	//console.log(sSqlStory);
	//console.dir(xhr.getAllResponseHeaders());

	if(!empty(sSqlStory))
	{
		var oSqlStory = $.parseJSON(sSqlStory.split('::br::').join('\n'));
		//console.dir(oSqlStory);
		Q.debug.fnShowSqlStory(oSqlStory, sAct, sFile);
	}

}

Q.debug.fnShowSqlStory  = function(oSqlStory, sAct, sFile)
{
	var i, aSQL;
	var sSqlType, sSQL, bResult, sSqlError, dTime;
	for(i in oSqlStory)
	{
		aSQL = oSqlStory[i];
		sSqlType = aSQL[0];
		sSQL = aSQL[1];
		bResult = aSQL[2];
		sSqlError = aSQL[3];
		dTime = aSQL[4];

		if(!(jQuery.browser.msie&&jQuery.browser.versionNumber<=10))
		{
			console.groupCollapsed('%s : %s : [%s] : %f sec : %s',sFile, sAct, sSqlType, dTime, ((bResult)?'Выполнен SQL запрос':'Ошибка в SQL запросе!'));
		}
		if(!bResult) console.warn(sSqlError);
		console.log('%cТекст SQL-запроса:','font-weight:bold');
		console.log(sSQL);
		if(!(jQuery.browser.msie&&jQuery.browser.versionNumber<=10))
		{
			console.groupEnd();
		}
	}
}

Q.debug.fnShowDebugStory = function(oStory, sAct, sFile)
{

	if(!empty(oStory)&&!(jQuery.browser.msie&&jQuery.browser.versionNumber<=10))
	{
		console.groupCollapsed('%s : %s : История работы препроцессора', sFile, sAct);
		Q.debug.fnNiceDir(oStory);
		console.groupEnd();
	}
}

Q.debug.fnNiceDir = function(oStory)
{
	var sKey;
	for(sKey in oStory)
	{
		if(oStory[sKey] instanceof Object)
		{
			console.groupCollapsed(sKey);
			Q.debug.fnNiceDir(oStory[sKey]);
			console.groupEnd();
		}
		else console.log('%c'+sKey+':',"color:blue",oStory[sKey]);

	}
}

Q.fnInit = function()
{

	Q.reports.fnInit();
	// #TODO FIXME
	// if(!$('body').is(".noauthwindow")) Q.oAuth.fnInit();

};

Q.fnAlert = function(sMsg, sType, sTitle, fnCallback)
{

	var sBtnType;

	switch(sType)
	{
		case "danger":
		case "error":
			sType = "danger";
			sBtnType = "danger";
			break;
		case "info":
		case "success":
			sBtnType = sType;
			break;
		case "warning":
			sType = "warning";
			sBtnType = "danger";
			break;
		case "notice":
			sType="warning";
			sBtnType = "warning";
			break;
		default:
			sType = "";
			sBtnType = "primary";
			break;
	}

	//alert("What's up?");
	return Q.fnOpenModal(
	{
		sId: "QAlertBox",
		sTitle: sTitle,
		sContent: '<div>'+sMsg+'</div>',
		iMinWidth: 460,
		iMaxWidth: 580,
		sClass: 'modal-'+sBtnType,
		oButtons:
		{
			"OK" :
			{
				bFocused: 1,
				sClass:"btn-outline-"+sBtnType,
				fnOnClick: function($btn, $Modal)
				{
					if(fnCallback) return fnCallback($btn, $Modal);
					else return true;
				}
			}
		}
	});

};

Q.fnAlertError = function(sMsg, fnCallback)
{
	this.fnAlert(sMsg, "error", "Ошибка", fnCallback);
};

Q.fnAlertSuccess = function(sMsg, fnCallback)
{
	this.fnAlert(sMsg, "success", "Успешно", fnCallback);
};

Q.fnAlertInfo = function(sMsg, fnCallback)
{
	this.fnAlert(sMsg, "info", "Информация", fnCallback);
};

Q.fnAlertWarning = function(sMsg, fnCallback)
{
	this.fnAlert(sMsg, "warning", "Предупреждение", fnCallback);
};

/**
 * Обязательными являются только первые 2 параметра.
 */
Q.fnConfirm = function(sMsg, fnOnOk, sOkBtnText, sType, fnOnCancel, sCancelBtnText)
{
	//alert("What's up?");

	var sBtnType;

	switch(sType)
	{
		case "danger":
		case "error":
			sType = "error";
			sBtnType = "danger";
			break;
		case "info":
		case "success":
			sBtnType = sType;
			break;
		case "warning":
			sType = "warning";
			sBtnType = "warning";
			break;
		case "notice":
			sType="warning";
			sBtnType = "warning";
			break;
		default:
			sType = "";
			sBtnType = "primary";
			break;
	}

	if(empty(fnOnOk))
	{
		console.log("fnConfirm : пропущен fnOnOk callback.");
		fnOnOk = function() {return true;};
	}
	if(empty(fnOnCancel)) fnOnCancel = function() {return true;};

	if(empty(sOkBtnText)) sOkBtnText = "OK";
	if(empty(sCancelBtnText)) sCancelBtnText = "Отмена";
	// if(empty(sDblBtnText)) sDblBtnText = "Сохранить и дублировать запись";


	var oButtons = {};
	oButtons[sOkBtnText] =
	{
		sClass:"btn-outline-"+sBtnType,
		fnOnClick: function($btn, $Modal)
		{
			return fnOnOk($btn, $Modal);
		}
	};
	oButtons[sCancelBtnText] =
	{
		sClass:"",
		bFocused:1,
		fnOnClick: function($btn, $Modal)
		{
			return fnOnCancel($btn, $Modal);
		}
	};
	// oButtons[sDblBtnText]

	Q.fnOpenModal(
	{
		sId: "QConfirmBox",
		sClass: "modal-"+sBtnType,
		sContent: '<div>'+sMsg+'</div>',
		oButtons: oButtons,
		iMinWidth: 460,
		iMaxWidth: 580
	} );

	return true;
};

//@deprecated!!
Q.fnShowLoader = function(sMsg)
{
	//alert("What's up?");
	/***
	$("#QLoaderBoxContent").empty();
	$("#QLoaderBoxContent").append(sMsg);
	$("#QLoaderBox").dialog('open');
	***/
	//alert("!!");
};

//@deprecated!!
Q.fnCloseLoader = function()
{
	//$("#QLoaderBox").dialog('close');
};


Q.reports.fnInit = function()
{


}

Q.reports.fnOpenForm = function(sUrl, sReportTitle, bLandscape, sAction)
{
	// sButtonName = "Показать отчёт";
	// if (sAction == 'download') {
	// 	sButtonName = "Скачать отчёт";
	// }
	// #FIXME Не заменяется название переменной sButtonName в функции. Пришлось городить if else оператор

	if (sAction == 'download')
	{
		Q.fnOpenModal(
		{
			sTitle: '<div class="one-line-ellipsis">'+"Параметры отчёта"+(sReportTitle?" «"+sReportTitle+"»":"")+'</div>',
			sId:"QReportFormBox",
			sUrl:sUrl,
			oButtons :
			{
				"Скачать отчёт":
				{
					sClass:"btn-primary",
					fnOnClick: function($btn, $Modal)
					{
						var $form = $Modal.find("form");
						$form.submit();
						return false; // чтобы не закрывать окно.
					}
				},
				"Отмена":
				{
					sClass:"",
					fnOnClick: function()
					{

					}
				}
			}
		});
	} else {
		Q.fnOpenModal(
		{
			sTitle: '<div class="one-line-ellipsis">'+"Параметры отчёта"+(sReportTitle?" «"+sReportTitle+"»":"")+'</div>',
			sId:"QReportFormBox",
			sUrl:sUrl,
			oButtons :
			{
				"Показать отчёт":
				{
					sClass:"btn-primary",
					fnOnClick: function($btn, $Modal)
					{
						var $form = $Modal.find("form");
						$form.submit();
						return false; // чтобы не закрывать окно.
					}
				},
				"Отмена":
				{
					sClass:"",
					fnOnClick: function()
					{

					}
				}
			}
		});
	}
}


Q.reports.fnOpenReport = function(sUrl, sReportTitle, bLandscape, sAction, oData)
{
	if(bLandscape === undefined) bLandscape = false;
	//console.log("bLandscape="+bLandscape);

	if(oData === undefined) oData = {};

	if(sAction == 'download')
	{
		sUrl += ((sUrl.split("?").length==2)?"&":"?")+$.param(oData);
		$("#FrameForExport").attr("src", sUrl);
		var LoaderInterval = setInterval(function(){ var $TextProgressIndicator = $("#text-loading"); if($TextProgressIndicator.text() == '...') { $TextProgressIndicator.text('.') } else { $TextProgressIndicator.text($TextProgressIndicator.text()+"."); }; window.clearInterval(this); } , 1500);
		Q.fnAlert("<div style=\"width: 460px\">Подождите, через несколько секунд начнется скачивание файла<b><span id=\"text-loading\">.</span></b></div>", null, "Загрузка скоро начнется", function(){ window.clearInterval(LoaderInterval) });
	}
	else
	{
		//console.log("Opening with oParams=");
		//console.dir(oData);
		Q.fnOpenModal(
		{
			sTitle: "Отчёт", //+(sReportTitle?" «"+sReportTitle+"»":""),
			sId: "QReportBox",
			iWidth		: (bLandscape?"302mm":"215mm"), // 5 мм про запас.
			iMaxWidth	: (bLandscape?"302mm":"215mm"), // 5 мм про запас.
			bNoPaddings : true,
			sContent: '<iframe width="100%" style="height: calc(100vh - 70px)" id="reportIframe" name="reportIframe" />',
			oButtons: {},
			oParams: oData,
			fnOnOpen: function($Modal)
			{
				postToIframe(oData, sUrl, "reportIframe");
			}
		} );
	}
}


/** Работа с модальными окнами ***/
Q.fnOpenModal = function(oOptions)
{
	//alert("fnOpenModal!!!");

	$("div.tooltip, div.popover").remove(); // Хак, который уберет все открытые тултипы в случае, чтобы избежать глюков

	// номер по счету данного модального окна.
	if(this.iModalNum == undefined) this.iModalNum = 1;
	else this.iModalNum++;

	var oDefaults =
	{
		sId			: "auto",
		sContent	: "",
		sUrl		: null,
		oParams		: {}, // параметры, которые передать на URL методом POST
		sTitle		: "HSERM", // _TODO: Брать из констант.
		iWidth		: 0, // 0 = auto
		iMinWidth	: 320, // Если передана меньшая ширина (но не 0), то автоматически выставится значение = iWidth
		iMaxWidth	: 960, // Если передана большая ширина, то автоматически выставится значение = iWidth
		iMinHeight  : null,
		iMaxHeight	: null,
		bNoPaddings : false,
		bHideCloseBtn : false,
		sClass		: null, // Класс, который будет установлен модальному окну.
		oButtons	: null,
		iTab		: 0,
		sTab		: null,
		bOpenLeft	: false,
		/***
		{
			"Закрыть":
			{
				sId:null,
				sClass:"",//"btn-primary",
				fnOnClick: function()
				{

				}
			}
		},
		/****/
		fnOnOpen: null,
		fnOnClose: null
	};

	oOptions = $.extend({}, oDefaults, oOptions);

	if(oOptions.sId == "auto") oOptions.sId = "Modal"+this.iModalNum;

	//alert(oOptions.oButtons);

	///alert(oOptions.sId+"\n\n"+$("#"+oOptions.sId).html());

	if(oOptions.bOpenLeft) oOptions.sClass=(oOptions.sClass === null)?'left':oOptions.sClass+' left';

	var $Modal;

	if(!($Modal = Q.fnGetModal(oOptions.sId)))
	{
		$("body").append
		(
			'\
			<div class="modal fade modal-qform show modal-wrapper '+oOptions.sClass+'" aria-labelledby="'+oOptions.sId+'" role="dialog" tabindex="-1" aria-modal="true" style="display:block;">\
				<div class="modal-dialog" style="width:640px; display:table" id="'+oOptions.sId+'">\
										<!-- display:table эмулирует недостающий нам width:fit-content. Без него при position:relative будет неправильная ширина -->\
				<div class="modal-content">\
					<div class="modal-header">\
						<div class="modal-right">\
							<a class="close" data-dismiss="modal" >&times;<\/a>\
						</div>\
						<h4 class="modal-title">Загрузка…<\/h4>\
					<\/div>\
					<div class="modal-body">\
						'+oOptions.sContent+'\
					<\/div>\
					<div class="modal-footer" style="display:none;"><\/div>\
				<\/div>\
				<\/div>\
			<\/div>\
			'
		);

		$Modal = $("#"+oOptions.sId);

	}
	else
	{
		oOptions.isUpdating = true;

		if(oOptions.iTab === null && oOptions.sTab === null)
		{
			// Если есть табы, то запомним, какой из них был выделен, чтобы потом его же и открыть.
			var $tabs = $Modal.find("ul.nav-tabs").not(".nav-stacked");
			if($tabs.length)
			{
				//oOptions.iTab = $tabs.find("li").index($tabs.find("li.active"));
				oOptions.sTab = $tabs.find("li.active").data("tab-name");
			}
		}
	}

	if(oOptions.sUrl)
	{
		/**
		 * @todo Пока грузится содержание для модального окна показывать лоадер
		 */
		Q.fnUpdateModalSettings($Modal, {sTitle:"Загружаю…"});
		$Modal.find("div.modal-body").load(oOptions.sUrl, oOptions.oParams,
			function(responseText, textStatus, XMLHttpRequest)
			{
				//if(!oOptions.isUpdating)
				Q.fnOpenModal_($Modal, oOptions);
			});
	}
	else
	{
		////if(!oOptions.isUpdating)
		Q.fnOpenModal_($Modal, oOptions);
	}


	return $Modal;

}

/* Вспомогательная функция */
Q.fnOpenModal_ = function ($Modal, oOptions)
{
	//console.log("fnOpenModal_");

	if(!oOptions.isUpdating)
	{
		$Modal.modal({keyboard:false, show:false, backdrop:false});
	}

	Q.fnUpdateModalSettings($Modal, oOptions);

	if(!oOptions.isUpdating)
	{
		$Modal.modal("show"); // чтобы ничего там не скакало, лучше все-таки будем показывать уже после задания css.

		if(oOptions.fnOnOpen) oOptions.fnOnOpen($Modal);
		// Подключим drag'n'drop
		$Modal.Drags({ handler: "div.modal-header" });

		$Modal.on('hide.bs.modal', function(e)
		{
			$("body div.tooltip").remove(); // Хак, который уберет все открытые тултипы в случае, чтобы избежать глюков

			if($(e.target).is($Modal) && oOptions.fnOnClose)
			{
				return oOptions.fnOnClose($Modal);
			}
		});

		$Modal.on('hidden.bs.modal',function()
		{
			$Modal.parent("div.modal-wrapper").prev(".modal-backdrop").remove();
			$Modal.parent("div.modal-wrapper").remove();
			//$Modal.remove();
		});
	}

	var $tabs = $Modal.find("ul.nav-tabs").not(".nav-stacked");
	if($tabs.length)
	{
		if(oOptions.sTab)
		{
			$tabs.find("li[data-tab-name="+oOptions.sTab+"]").children("a").tab('show');
		}
		else
			$tabs.find("a").eq(oOptions.iTab).tab('show');
	}


	if(oOptions.isUpdating) $Modal.trigger("shown"); // Вызовем событие показа окна для инициализации скриптом, которые могут быть привязаны к открытию…


	// Строчка ниже нужна для того, чтобы работало в Internet Explorer. Выяснено экспериментально, практически чудом. Ни на что вроде не влияет.
	$(document).off('focusin.modal');

	////console.dir(oOptions);

	/*****
//	console.dir($Modal.find("div.modal-header a.close"));
	$Modal.find("div.modal-header a.close").unbind('click').remove().click(function(e)
	{
		alert('%%%%%');
		$Modal.modal('hide');
		e.stopPropagation();
	});
	****/

}

Q.fnUpdateModalSettings = function($Modal, oOptions)
{
	var oDefaults =
	{
		sTitle		: null,
		iWidth		: null, // 0 = auto // На самом деле теперь уже необязательно integer!!
		iMinWidth	: null, // Если передана меньшая ширина (но не 0), то автоматически выставится значение = iWidth
		iMaxWidth	: null, // Если передана большая ширина, то автоматически выставится значение = iWidth
		iMinHeight  : null,
		iMaxHeight	: null,
		bNoPaddings : null,
		bHideCloseBtn : null,
		sClass		: null, // Класс, который будет установлен модальному окну.
		oButtons	: null
	};

	oOptions = $.extend({}, oDefaults, oOptions);

	if(oOptions.iWidth !== null)
	if(Number(oOptions.iWidth))
	{
		//console.log(Number(oOptions.iWidth));
		if(oOptions.iMaxWidth !== null)
		if(Number(oOptions.iMaxWidth))
			if(oOptions.iWidth > oOptions.iMaxWidth) oOptions.iMaxWidth = oOptions.iWidth;

		if(oOptions.iMinWidth !== null)
		if(Number(oOptions.iMinWidth))
			if(oOptions.iWidth && (oOptions.iWidth < oOptions.iMinWidth)) oOptions.iMinWidth = oOptions.iMinWidth;

	}

	//var $Modal = Q.fnGetModal(oOptions.sId);

	if($Modal)
	{
		if(!empty(oOptions.sTitle)) $Modal.find("div.modal-header h4").html(oOptions.sTitle);
		if(oOptions.bHideCloseBtn !== null) $Modal.find("div.modal-header a.close").toggle( ! Boolean(oOptions.bHideCloseBtn) );

		//console.dir(oOptions);

		if(oOptions.iMinWidth !== null)
			$Modal.css({ 'min-width': oOptions.iMinWidth ? oOptions.iMinWidth+"px" : "auto" });
		if(oOptions.iMaxWidth !== null)
			$Modal.css({ 'max-width': oOptions.iMaxWidth ? oOptions.iMaxWidth + (Number(oOptions.iMaxWidth)?"px":"") : "auto" });
		if(oOptions.iMinHeight !== null)
			$Modal.css({ 'min-height': oOptions.iMinHeight ? oOptions.iMinHeight + (Number(oOptions.iMinHeight)?"px":"") : "auto" });
		if(oOptions.iMaxHeight !== null)
			$Modal.css({ 'max-height': oOptions.iMaxHeight ? oOptions.iMaxHeight + (Number(oOptions.iMaxHeight)?"px":"") : "auto" });

		if(oOptions.bNoPaddings !== null)
			$Modal.find("div.modal-body").toggleClass("modal-body-nopadding", Boolean(oOptions.bNoPaddings));



		if(oOptions.iWidth !== null)
		{
			if(oOptions.iWidth) $Modal.width(oOptions.iWidth);
			else $Modal.css("width", "auto");
			var iWidthVP = $(window).width();
			var iLeft = 0;
			if ($Modal.outerWidth() < iWidthVP){
				iLeft = iWidthVP/2 - $Modal.outerWidth() / 2;
			}
			//$Modal.css({'left':"50%", 'margin-left': function () { return -($(this).outerWidth() / 2); }});
			$Modal.css({left:iLeft, margin:"0"});
		}

		if(oOptions.oButtons !== null)
		{
			var $Footer = $Modal.find("div.modal-footer")
			if(empty(oOptions.oButtons)) $Footer.empty().hide();
			else
			{
				$Footer.empty().show();
				var oButton;
				var sButton_Title;
				var sButton_Class;
				var fnButton_OnClick;
				var sShortcut, sAddShortcut="";
				var sAddIcon="";
				var sHint="";
				var bShortcutCellar;
				var bBold=0;
				var bHidden=0;
				for (sButton_Title in oOptions.oButtons)
				{
					//console.log("oButton=%o",oButton);
					oButton = oOptions.oButtons[sButton_Title];

					sButton_Class =  oButton.sClass;
					if(sButton_Class === undefined) sButton_Class = '';

					if(!sButton_Class.match(/\bbtn-/)) sButton_Class = 'btn-light ' + sButton_Class;

					fnButton_OnClick = oButton.fnOnClick;

					sShortcut = oButton.sShortcut;
					bBold     = oButton.bBold;

					if(oButton.sHint === undefined) sHint = "";
					else sHint     = oButton.sHint;

					bShortcutCellar = oButton.bShortcutCellar;
					if(empty(bShortcutCellar)) bShortcutCellar = 0;
					if(!empty(sShortcut)) sAddShortcut = ' <small'+(bShortcutCellar?' class="cellar"':'')+'>'+sShortcut+'</small>';
					else sAddShortcut = "";

					if(!empty(oButton.sIcon)) sAddIcon = '<i class="glyphicon glyphicon-'+oButton.sIcon+'"></i>';
					else sAddIcon = '';

					var $btn;

					if(!empty(bBold))
					{
						$btn = $Footer
								.append('<a href="#" title="'+ sHint +'" data-button-title="' + sButton_Title + '" class="btn ' + sButton_Class + '" data-dismiss="modal">' + sAddIcon + '<b>' + sButton_Title + '</b>' + sAddShortcut+'</a>');
					}
					else
					{
						$btn = $Footer
								.append('<a href="#" title="'+ sHint +'" data-button-title="' + sButton_Title + '" class="btn ' + sButton_Class + '" data-dismiss="modal">' + sAddIcon + sButton_Title + sAddShortcut+'</a>');
					}


					$btn = $btn.find("a[data-button-title='"+sButton_Title+"']")
									.click(function()
									{
										var $btn = $(this);

										//if($btn.is(":disbaled") || $btn.is(".disabled")) return false;

										var sButton = $btn.attr("data-button-title");
										var fnButton_OnClick = oOptions.oButtons[sButton].fnOnClick;
										if(fnButton_OnClick)
											return fnButton_OnClick($(this), $Modal);
										else
											return true;
									});
					if(oButton.bFocused) $btn.focus();
					if(oButton.bHidden)  $btn.hide();
					if(!empty(oButton.sId)) $btn.attr("id", oButton.sId);
				}
			}
		}
	};

}


Q.fnGetModal = function(sId)
{
	if($("#"+sId).length)
	{
		return $("#"+sId);
	}
	else return false;
}


Q.fnOpenWithPost = function(sUrl, sData)
{
	// Получим массив значений (преобразуем из строки URL-вида)
	var match = sData.match(/[^=&?]+\s*=\s*[^&#]*/g);
	var params = {}; // вот он, сейчас будем наполнять…

	if(match !== null)
	{
		for ( var i = match.length; i--; ) {
		  var spl = match[i].split("=");
		  var name = spl[0].replace("[]", "");
		  var value = spl[1];

		  value = value.toString();

		  params[name] = params[name] || [];
		  params[name].push(value);
		}
	}

 	// The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", sUrl);
    form.setAttribute("target", "_blank");

    //Fill the hidden form
    if (typeof params === 'string') {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", 'data');
        hiddenField.setAttribute("value", params);
        form.appendChild(hiddenField);
    }
    else {
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                //if(typeof params[key] === 'object'){
                //    hiddenField.setAttribute("value", JSON.stringify(params[key]));
                //}
                //else{
                    hiddenField.setAttribute("value", params[key]);
                //}
                form.appendChild(hiddenField);
            }
        }
    }

    document.body.appendChild(form);
    form.submit();
}


$(window).on(($.browser.opera ? "keypress" : "keydown"), function(e)
{
	if(e.shiftKey)
	$('body').toggleClass("shift-pressed", e.shiftKey);
});


$(window).on(('keyup'), function(e)
{
	if (!e.shiftKey)
	{
		$('body').toggleClass("shift-pressed", e.shiftKey);
	}
});

